const zh = {
  title: 'QIN',
  sTitle: '前言',
  des: ['中华文明源远流长。在绵延两千多年的历史长河中，秦人开掘智慧，创造革新，缔造文字、法律、户籍、交通、水利、行政、勋爵、冶炼、度量衡等一批功在千秋的先进制度，凝聚雄浑、奋勇、豪迈、求实的精神宝藏，铭刻大秦帝国强盛辉煌的时代坐标。时光荏苒，沧海桑田，在关中大地，南北之间，秦人的后裔们继以传承、创造、拼搏，砥砺前行。', '秦始皇陵兵马俑，一列列绝美、恢弘的五彩兵俑，两千多年后出土临世，被冠以“世界第八大奇迹”的称号，跻身世界文明鉴录。由尼泊尔中国文化中心和陕西省文化和旅游厅共同主办的“秦|QIN—兵马俑的前世今生”现代艺术线上展，将历史、文化、科技相融合，构筑云端展览动线，徐徐揭开世界奇观的大幕。一场呈现古中国文明智慧，昭示中华文化魅力的云端际会，解构兵马俑文化内涵与艺术神采。卓绝千古的画笔，勾勒兵马俑前世今生画卷，逐一解读大秦文明、历史的流韵及给当代中国留下的文化印迹。'],
  menu: [
    { text: '前言', url: '/index' },
    { text: '历史绵迭', url: '/history' },
    { text: '览古观今', url: '/warriors' }
  ],
  footer: [
    {
      title: '主办：',
      item: ['尼泊尔中国文化中心', '陕西省文化和旅游厅']
    },
    {
      title: '承办：',
      item: ['陕西文一国际文化发展有限公司']
    },
    {
      title: '特别鸣谢：',
      item: [`秦始皇帝陵博物院`]
    }
  ],
  history: {
    menu: '历史绵迭',
    // title: ['在缥缈浩瀚的宇宙，向斗转星移的时空，', '一段剪影的开始，缔造一代君王的宏图；', '一程幻象的波动，归藏一幕主角的吟诵。', '秦，在华夏穹庐掀动着历史氤氲；', '在九州海宇凿刻着未来圭皋。', '千载岁月，迅疾绵跌，', '一个王朝、一位君主、', '一川巨筑、一阵戎麾，隐于荒草疏壑。', '光影流转，时空调换，', '一阵戎麾的现世，伯功君王的故事，', '就此揭开帷幕；', '震撼世界的遗迹，从此使人称奇。', '兵马战俑，焕彩从容矗立，关于秘密，', '一一陈述。'],
    title: ['在缥缈浩瀚的宇宙，向斗转星移的时空，一段剪影的开始，缔造一代君王的宏图；一程幻象的波动，归藏一幕主角的吟诵。秦，在华夏穹庐掀动着历史氤氲；在九州海宇凿刻着未来圭皋。千载岁月，迅疾绵跌，一个王朝、一位君主、一川巨筑、一阵戎麾，隐于荒草疏壑。', '光影流转，时空调换，一阵戎麾的现世，伯功君王的故事，就此揭开帷幕；震撼世界的遗迹，从此使人称奇。兵马战俑，焕彩从容矗立，关于秘密，一一陈述。'],
    part1: {
      title: '前世画卷',
      article: ['公元前378年，秦献公在秦国境内，废止自夏商以来的人殉制度，出现以其它材质的人形俑殉葬，陶俑、木俑、石俑等来代替人殉。兵马俑在这种殉葬礼制下应运而生，兵马俑，在秦始皇修筑期间，由技艺精湛的社会底层陶工烧制。', '兵马俑的制作过程，先用黄泥烧制陶制模型，后填充黄土制作胎形，再覆盖细泥彩绘颜色入窑烧制，大部分的俑，都经过拼接处理，有的先烧后拼，火候均匀、色泽单纯、硬度很高，色彩艳丽。粉绿、朱红、枣红、粉红、粉紫、天蓝、白色、赭石色为着色的基本色调。', '1974年3月兵马俑，被中国临潼一位农民打井时揭开神秘面纱，迄今共发现4个俑坑，一号、二号、三号坑都有紧罗密布的兵俑阵列，四号坑只有封土，并无兵俑。在一、二、三号坑中共发掘出8000多尊兵马俑。', '兵马俑主要分为士兵和军吏两个大类，根据形态又分为车兵俑、立射俑、跪射俑、武士俑、军吏俑、骑兵俑、驭手俑、车马俑、鞍马俑等。1987年12月，秦始皇陵及兵马俑被列入世界遗产名录，从此兵马俑成为陕西闻名世界的文化名片，成为国外领导人和游客游访中国，必到的文化地标。']
    },
    part2: {
      title: '考古发现',
      article: ['位于今陕西省西安市临潼区秦始皇陵以东1.5千米处的兵马俑坑内，从1974年3月发现到2009年6月，共进行了3次较大规模的发掘。秦始皇兵马俑陪葬坑坐西向东，三坑呈品字形排列，兵马俑坑是地下坑道式的土木结构建筑，即从地面挖一个深约5米的大坑，在坑的中间筑起一条条平行的土隔墙。', '墙的两边排列木质立柱，柱上置横木，横木和土隔墙上密集地搭盖棚木，棚木上铺一层苇席，再覆盖黄土，从而构成坑顶，坑顶高出当时的地表约2米。俑坑的底部用青砖墁铺。坑顶至坑底内部的空间高度为3.2米。陶俑、陶马放进俑坑后，用立木封堵四周的门道，门道内用夯土填实，就形成了一座封闭式的地下建筑。']
    },
    part3: {
      title: '兵马俑印象',
      article: '兵马俑从身份上区分，主要有士兵与军吏两大类，军吏又有低级、中级、高级之别。一般士兵不戴冠，而军吏戴冠，普通军吏的冠与将军的冠又不相同，甚至铠甲也有区别。其中的兵俑包括步兵、骑兵、车兵三类，根据形态又分为车兵俑、立射俑、跪射俑、武士俑、军吏俑、骑兵俑、驭手俑、车马俑、鞍马俑等。'
    },
    first: {
      title: '一号青铜战车',
      des: '一号战车整体长225厘米，高152厘米，重1061公斤。它有一个长0.45米，宽0.74米的长方形小车。战车的马车上伸出一个天篷，为车夫提供遮阳伞，面积约1.17平方米。天篷由两部分组成：一是底座，二是带把手的天篷。顶篷是可拆卸的，因此可以放入和取出。'
    },
    second: {
      title: '文官俑',
      des: '文官的手插在袖子里。与兵马俑不同的是，文官不带武器，而是双手交叉于腰，披着宽松的长袖，腰间挂着一把刀和磨刀器。这把刀的功能类似于橡皮擦，用来剥去刻在竹木上的不正确的音符。据认为，这些陶俑可能代表了在中央政府服务的文官。'
    },
    third: {
      title: '跪射俑',
      des: '那个跪着的弓箭手是在二号坑里发现的。弓箭手呈跪姿，右膝放在地上，左膝抬高。他的右臂张开，而左臂放在他抬起的左膝上。这座雕像的姿势表明，他最初手持十字弓准备射击。他们和站立的弓箭手组成了军队的箭阵。跪着的弓箭手被放置在队形的中心，而站立的弓箭手被放置在周围。'
    },
    fourth: {
      title: '站射俑',
      des: '站立的弓箭手是一种身穿无甲战袍的步兵。站立的弓箭手被小心地用他垂下的左臂和举起的右臂在他的胸前。他们的手的位置显示他们拿着十字弓。两脚分开站立，右脚向外，左脚向前。双手的姿势表明，站立的弓箭手会将弓箭指向下方，而跪着的弓箭手则会将弓箭指向上方。'
    },
    fifth: {
      title: '高级军吏俑',
      des: '官是兵马俑坑中级别最高的人物。到目前为止，已从坑中挖掘出9名高级官员。其中两个人穿着战袍，另外七个人穿着盔甲。军官的身高、衣着和头饰都表明他的地位高。'
    },
    sixth: {
      title: '中级军官',
      des: '中层军官，他的平顶帽子，方头鞋和脖子上华丽的围巾可能暗示他的委任。从他的手和胳膊的位置可以清楚地看出，这个人曾经持有的武器早已腐烂了。'
    },
    seventh: {
      title: '百戏俑',
      des: '这些雕像的尺寸与真人相似，只是穿着短裙，形状与今天女性的迷你裙相似。有些人显得高大强壮，而有些人则显得矮小苗条。根据对修复后的俑的分析，考古学家表示，与兵马俑不同，这些陶俑可能是在秦始皇的皇宫里服役的杂技演员，描绘了秦朝辉煌的杂技艺术。'
    },
    eighth: {
      title: '车夫跪俑',
      des: '第二辆战车还有一位车夫，身高51厘米，头戴礼帽，身穿长袍，腰间佩带长剑。他脸上还带着微笑和尊敬的表情。在跪的位置，他伸出他的双手向前小心地驾驶与缰绳在他的手中。'
    },
    ninth: {
      title: '骑兵和他的带鞍战马俑',
      des: '骑兵站在马的左前侧，用袖子及膝的长袍握住缰绳。他站在马的左边，手里握着缰绳。骑兵的战袍和铠甲比其他战士的略短，也不带肩片，系在下巴上的小而紧的帽子是为了防止骑马时头发被风吹散。他还穿靴子，靴子的形状与今天常见的雨靴相似。骑兵的制服设计得又紧又短，便于在战斗中骑上马和使用弓箭。'
    }
  },
  warriors: {
    menu: '览古观今',
    des: '请点击下方 START 进入VR全景体验',
    title: '距今两千五百载岁月的兵马俑遗迹，从一出土就被称奇为世界第八大奇迹，继而又被世界遗产名录收录，成为永垂不朽的历史文化瑰宝。如今，融合现代科技手段和创新手法的展示场景，通过互联网+向人们展示兵马俑的魅力。VR兵马俑展馆全景，一幕幕动态的场景，描绘出他的现世现状...... ',
    part1: {
      title: 'VR全景',
      article: '数字博物馆，以线上VR全景技术作为载体，将兵马俑1号坑及铜车马展厅曲面全方位展示，整体像素达到200亿级别，让你足不出户，透过电脑，全景透视8000座兵马俑的壮观景象......'
    }
  },
  ancient: {
    title: ['兵马俑作为世界文化的历史瑰宝，从诸多角度去发觉探索，都能发掘出不一样的价值。从艺术角度出发，兵马俑个中雄浑的姿态，都能成为艺术创作的灵感源泉。', '兵马俑作为世界文化的历史瑰宝，从诸多角度去发觉探索，都能发掘出不一样的价值。从艺术角度出发，兵马俑个中雄浑的姿态，都能成为艺术创作的灵感源泉。', '比如取材兵马俑元素，融合阿拉伯文化印象，创作编导的现代舞《共生》；取材兵马俑历史文化要素创作的秦腔剧《秦俑魂》剧本；取材于兵马俑前世今生，创作的《古今大战秦俑情》电影，一系列对兵马俑艺术价值探索的活动，被一部部优秀的艺术作品呈现。'],
    part1: {
      title: '共生',
      article: '作品创作主要以共生为主题，阐述不同文化之间、不同教育和习惯之间的相似点共同点即共生。看似相同的事物，其实都有自己的个性和魅力；看似不同的事物，却有着千丝万缕的共性和联系…以兵马俑元素混搭以阿拉伯风为主要创作灵感的现代舞《共生》，在长达60分钟的表演里,舞蹈演员通过肢体动作和夸张的面部表情,来模仿各种人的意识形态和精神面貌,用艺术语言来描述生活化和历史意义的事物，果真应了那句“艺术源于生活并高于生活”。'
    }
  },
  culture: {
    title: '艺术，是取源于自然、生活物质形态存在的独特表达形式，存在变与不变的大道之中。不论东方与西方，不同文化之间的壁垒，影响艺术创作风格，但整体艺术形式求同存异，各有千秋。兵马俑与乐高积木的融合创新，是为，中西方文化碰撞的杰作。几万枚乐高积木，堆积出庄严肃穆的兵马俑形象，蔚为大观。',
    part1: {
      title: '乐高兵马俑',
      article: '乐高兵马俑，由蒋晟辉工作室创作搭建，一尊以灰黄为色彩基调，一尊以红、黄、蓝、黑为基础色调。其参考兵马武士俑的各种数据，1：1真实还原，两尊兵马俑共用乐高积木模块12万余块，耗时800多个小时。乐高兵马俑，是中西文化完美融合展现的艺术行为，也是中西艺术碰撞的结晶。'
    }
  }
}

export default zh
